import { useParams } from "react-router-dom"
import { appStore } from "../store/appStore"
import {
    cinemaHref,
    DEFAULT_CINEMA_SLUG,
    isCinemaSlug,
    slugForCinemaId,
} from "../lib/cinemaSlugs"

export function useCinemaSlug(): string {
    const { place } = useParams()
    const { cinema, locationSelected } = appStore()
    if (isCinemaSlug(place)) return place
    return (locationSelected && slugForCinemaId(cinema.id)) || DEFAULT_CINEMA_SLUG
}

export function useCinemaHref() {
    const slug = useCinemaSlug()
    return (path: string) => cinemaHref(slug, path)
}
